import React from 'react';
import './strip.scss';

// La tira ES el control: al pulsarla, el panel navega hacia la cápsula que
// nombra. La flecha es un glifo tipográfico (→), no el icono del design
// system — es texto en línea, no un control (D4, registro de decisiones).
const ContinuationStrip = ({ kind, label, axis, onNavigate }: Props) => (
  <button type="button" className={`rdp-strip rdp-strip--${kind} rdp-strip--${axis.toLowerCase()}`} onClick={onNavigate}>
    {kind === 'before' ? `← ${label}` : `${label} →`}
  </button>
);

interface Props {
  kind: 'before' | 'after',
  label: string,
  axis: 'A' | 'B',
  onNavigate: () => void
}

export { ContinuationStrip };
